import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BookInfoModalComponent } from '@app/web/modals/book-info-modal/book-info-modal.component';
import { BookModel, GetPlatformInteractor, UserService } from '@together/common';
import { DateTime, Interval } from 'luxon';
import { SimpleModalService } from '@looorent/ngx-simple-modal';

@Component({
    selector: 'app-book-thumbnail',
    templateUrl: './book-thumbnail.component.html',
    styleUrls: ['./book-thumbnail.component.scss'],
})
export class BookThumbnailComponent implements OnInit {
    @Input() book: BookModel;
    @Input() onlyImage = false;
    @Input() isFav = false;
    @Input() ownerAvatar = '';
    @Input() allowPurchase = false;
    @Input() isContentRestricted = false;

    @Output() public toggleFavorite = new EventEmitter<BookModel>();
    @Output() public selected = new EventEmitter<BookModel>();

    public isLoggedIn = false;
    private isWeb: boolean;

    constructor(
        protected modalService: SimpleModalService,
        protected userService: UserService,
        protected getPlatform: GetPlatformInteractor,
    ) {}
    public async ngOnInit() {
        this.isLoggedIn = await this.userService.isLoggedIn();
        this.isWeb = this.getPlatform.isWeb();
    }

    public purchaseAction() {
        if (this.isWeb) {
            this.modalService.addModal(BookInfoModalComponent, {
                book: this.book,
                purchase: this.book.purchaseDetails,
                isLoggedIn: this.isLoggedIn,
                allowPurchase: this.allowPurchase,
            });
        }
    }

    public getRentalDaysLeft(): string {
        if (this.book?.purchaseDetails?.rentalStartDate) {
            const rentalEndDate = DateTime.fromJSDate(this.book.purchaseDetails.rentalStartDate).plus({
                days: this.book.purchaseDetails.rentalDuration,
            });
            const i = Interval.fromDateTimes(DateTime.now(), rentalEndDate);
            return i.length('days').toFixed(0);
        }
        return null;
    }
}
